"use client";

import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { Card } from "@heroui/card";

export function FarmerWarningBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-full"
    >
      <Card className="bg-yiedl-gray-900 border border-yiedl-primary/20 rounded-xl p-4 sm:p-6 shadow-lg">
        <div className="flex flex-col items-center gap-4 sm:gap-6">
          {/* Glassmorphic icon container with farmer emoji */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
            className="relative"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-yiedl-primary/30 to-yiedl-primary/20 backdrop-blur-sm rounded-2xl flex items-center justify-center shadow-lg border border-yiedl-primary/30">
              <span
                className="text-4xl sm:text-5xl"
                role="img"
                aria-label="farmer"
              >
                👨‍🌾
              </span>
            </div>
            {/* Decorative glow */}
            <div className="absolute inset-0 bg-yiedl-primary/20 rounded-2xl blur-xl -z-10" />
          </motion.div>

          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.2 }}
            className="text-center space-y-2 sm:space-y-3 max-w-md"
          >
            <h3 className="text-lg sm:text-xl font-semibold text-white flex items-center justify-center gap-2">
              <AlertTriangle className="w-5 h-5 text-yiedl-primary" />
              Hey there, farm enthusiast!
            </h3>
            <p className="text-sm sm:text-base text-gray-400">
              We&apos;ve noticed some{" "}
              <span className="font-semibold text-yiedl-primary">
                unusual farming activity
              </span>{" "}
              on your account. Not the kind that grows delicious vegetables
              though! 🌾
            </p>
            <p className="text-sm sm:text-base text-gray-400">
              If you think there&apos;s been a mixup, please contact us at{" "}
              <a
                href="mailto:updates@pulsar.money"
                className="text-yiedl-primary hover:text-yiedl-primary/80 underline underline-offset-2 font-medium transition-colors"
              >
                updates@pulsar.money
              </a>{" "}
              and we&apos;ll help sort things out.
            </p>
          </motion.div>
        </div>
      </Card>
    </motion.div>
  );
}
